import axios from "axios";
import env from "../Env";
import moment from "moment";

export default {
  getData: function(token, typescsv) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      console.log(process.env.VUE_APP_baseUrl);
      let url = `${process.env.VUE_APP_baseUrl}masterrecord/${typescsv}?${t}`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMasterData: function(token, typescsv) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}masterdata/masterdata`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDocumentType: function(token) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();

      let url = `${process.env.VUE_APP_baseUrl}masterdata/documenttypes`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getIncidentTypes: function(token) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();

      let url = `${process.env.VUE_APP_baseUrl}masterdata/incidenttypes`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSubOfferingTypes: function(token) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();

      let url = `${process.env.VUE_APP_baseUrl}masterdata/subofferingtypes`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDocumentType: function(token) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();

      let url = `${process.env.VUE_APP_baseUrl}masterdata/documenttypes`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRateCards: function(token, ratecardid) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}sow/ratecards`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
